import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class WatchersCount extends Field {
  static attributesForModel() {
    return ['watchersCount'];
  }

  get title() {
    return 'Watchers count';
  }

  exampleContents(): FieldContentsData {
    return { text: 3, icon: { name: 'fa-regular fa-eye' } };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.watchersCount) {
      return {
        text: record.watchersCount,
        icon: { name: 'fa-regular fa-eye' },
      };
    }

    return {};
  }
}
